import { walletActions } from 'viem';
import {} from '../createConfig.js';
import {} from '../types/utils.js';
import { getConnectorClient, } from './getConnectorClient.js';
export async function getWalletClient(config, parameters = {}) {
    const client = await getConnectorClient(config, parameters);
    client.extend(walletActions);
    // @ts-ignore
    return client.extend(walletActions);
}
//# sourceMappingURL=getWalletClient.js.map